import styled from "@emotion/styled";
// @ts-expect-error
import units from "design-units";

export const MainTabSection = styled.div`
  margin: 0 2rem 2rem;
  width: 100%;

  display: flex;
  flex-direction: column;
`;

export const StyledHeading = styled.div`
  margin-left: 16px;
  font-family: ${(props) => props.theme.fontFamily.primary};
  ${units({
    color: "grey",
    fontSize: "12px",
  })};
`;
